function setup() {
    var typed = new Typed("#slogan", {
        strings: [
            "The easy button for financial data delivery",
            "Redefining the financial data ecosystem",
            "Bridging data providers and data consumers",
            "Democratized access to premium-quality information",
        ],
        typeSpeed: 50,
        loop: true,
        smartBackspace: true,
        backSpeed: 30,
        backDelay: 3000,
    });

    const isDark = document.documentElement.classList.contains('dark');

    VANTA.GLOBE({
        el: "#three-container",
        mouseControls: false,
        touchControls: false,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1,
        scaleMobile: 1.0,
        // spacing: 19.0,
        // points: 22.0,
        // maxDistance: 15.0,
        // showDots: false,
        color: 0x097dbf,
        color2: 0x097dbf,
        backgroundColor: isDark ? 0x0f1419 : 0xffffff,
    });

    let animation = null;
    let animationRight = null;

    const animationOnScroll = () => {
        const isLg = document.getElementById("breakpoint-lg")?.offsetParent !== null;

        if (isLg && animation) {
            const circleLeft = document.querySelector(".circle-left");
            const rect = circleLeft.getBoundingClientRect();

            const elementTop = rect.top;
            const elementBottom = rect.bottom;
            const windowHeight = window.innerHeight;
            if (elementBottom < 0 || elementTop > windowHeight) return;

            const visiblePx = Math.min(elementBottom + 200, windowHeight) - Math.max(elementTop + 200, 0);
            const percentVisible = visiblePx / rect.height;

            animation.seek(animation.duration * percentVisible);
            animationRight.seek(animationRight.duration * percentVisible);
        }
    };

    const setupAnimation = () => {
        const isLg = document.getElementById("breakpoint-lg")?.offsetParent !== null;
        if (isLg && window.innerWidth >= 1024) {
            animation = animation ?? anime({
                targets: ".circle-left",
                width: "65%",
                duration: 10000,
                easing: "easeInOutSine",
                autoplay: false,
                borderRadius: [
                    "40% 60% 60% 40% / 50% 50% 50% 50%",
                    "30% 70% 70% 30% / 50% 50% 50% 50%",
                ],
            });

            animationRight = animationRight ?? anime({
                targets: ".circle-right",
                width: "65%",
                duration: 10000,
                easing: "easeInOutSine",
                autoplay: false,
                borderRadius: [
                    "60% 40% 40% 60% / 50% 50% 50% 50%",
                    "70% 30% 30% 70% / 50% 50% 50% 50%",
                ],
            });

        }
        if (!isLg) {
            document.querySelector(".circle-left").setAttribute("style", "");
            document.querySelector(".circle-right").setAttribute("style", "");
        } else {
            animationOnScroll();
        }
        document.addEventListener("scroll", animationOnScroll);
    };

    setupAnimation();
    window.addEventListener("resize", () => {
        setupAnimation();
    });
}

export default setup;